export default __webpack_public_path__ + "static/media/bars.e8db7520.svg";